import { render, staticRenderFns } from "./WarningList.vue?vue&type=template&id=a129c0ae"
import script from "./WarningList.vue?vue&type=script&lang=js"
export * from "./WarningList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports